import { NationalityType, occupationList } from '@/models/self-checkin/accommodation-info'
import { SelfCheckInState } from '@/models/self-checkin'

export const getTranslateOccupation = value => {
  const occupation = occupationList.find(i => i.value === value)

  return occupation?.name
}

export const IdentificationRequirement = {
  None: 'none',
  License: 'license',
  Passport: 'passport',
} as const
export type IdentificationRequirement = (typeof IdentificationRequirement)[keyof typeof IdentificationRequirement]

/**
 * 現地で提出を求める本人確認書類を返す。
 *
 * 事前チェックインで本人確認が登録済み (hasIdentification) の場合は、施設設定に関わらず求めない。
 * バックエンド未反映の間は hasIdentification が undefined になるため、従来どおり施設設定のみで判断される。
 */
export const getIdentificationRequirement = (state: SelfCheckInState, nationality: string | undefined): IdentificationRequirement => {
  if (state.selectReservation?.hasIdentification) {
    return IdentificationRequirement.None
  }
  if (nationality !== NationalityType.Jp) {
    return state.setting.accommodation.requiredForeignIdentify ? IdentificationRequirement.Passport : IdentificationRequirement.None
  }
  return state.setting.accommodation.requiredJapaneseIdentify ? IdentificationRequirement.License : IdentificationRequirement.None
}
